/* file description */
import React, { useEffect, useState } from 'react';
import styles from './index.module.less';
import { TabsItem } from './TabsItem';

interface ProductMixProps {
  field: any;
  sceneType?: string;
  chooseProduct: any;
  linkShowModalContrulor: any;
  onChange: any;
  setOptionList: any;
  customCode?: string;
  onlyCode?: string;
}

const ProductSearch: React.FC<ProductMixProps> = (props) => {
  const sceneType = props?.sceneType || 'product_sale_default';
  return (
    <div className={styles.product_box}>
      <TabsItem
        field={props.field}
        config={props.config}
        columnFrom={props.columnFrom}
        setRowData={props.setRowData}
        customCode={props.customCode}
        onlyCode={props.onlyCode}
        sceneType={sceneType}
        chooseProduct={props.chooseProduct}
        linkShowModalContrulor={props.linkShowModalContrulor}
        onChange={props.onChange}
        setOptionList={props.setOptionList}
      />
    </div>
  );
};

export default ProductSearch;
